import { render, staticRenderFns } from "./FlightDetails.vue?vue&type=template&id=35b6d758&scoped=true&"
import script from "./FlightDetails.vue?vue&type=script&lang=js&"
export * from "./FlightDetails.vue?vue&type=script&lang=js&"
import style0 from "./FlightDetails.vue?vue&type=style&index=0&id=35b6d758&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b6d758",
  null
  
)

export default component.exports